import type { RepositoryAnalysis } from '../../types/analysis.types';
import { now } from './common';
import { vibeMapperMaintenanceScore } from './maintenanceScore';
import { vibeMapperRepositoryDetails } from './repositoryDetails';
import { vibeMapperCategories } from './categories';
import { vibeMapperStrengths, vibeMapperGaps, vibeMapperQuickWins } from './findings';
import { vibeMapperRecommendations } from './recommendations';
import { vibeMapperGapsDetailed } from './gapsDetailed';
import { vibeMapperCurrentState } from './currentState';
import { vibeMapperValidation } from './validation';
import { vibeMapperDocuments } from './documents';

export { vibeMapperMaintenanceScore };

/**
 * Repository analysis demo data for Crescendo -
 * a full-stack developer productivity platform.
 */
export const vibeMapperAnalysis: RepositoryAnalysis = {
  repositoryId: 'crescendo-labs-crescendo-demo',
  repositoryName: 'crescendo-labs/crescendo',
  score: 74,
  grade: 'B',
  filesCount: 1574,
  languages: [
    { name: 'TypeScript', percentage: 63.4 },
    { name: 'Python', percentage: 15.0 },
    { name: 'Terraform', percentage: 8.3 },
    { name: 'Shell', percentage: 5.5 },
    { name: 'Other', percentage: 7.8 },
  ],
  scanDate: now,
  scanDuration: 142,

  maintenanceScore: vibeMapperMaintenanceScore,

  overview: {
    totalChecks: 45,
    passedChecks: 30,
    failedChecks: 8,
    warningChecks: 7,
  },

  repositoryDetails: vibeMapperRepositoryDetails,
  categories: vibeMapperCategories,
  strengths: vibeMapperStrengths,
  gaps: vibeMapperGaps,
  quickWins: vibeMapperQuickWins,
  recommendations: vibeMapperRecommendations,
  gapsDetailed: vibeMapperGapsDetailed,
  currentState: vibeMapperCurrentState,
  _validation: vibeMapperValidation,
  documents: vibeMapperDocuments,
};
